import { createContext } from 'react';

const LanguageFormContext = createContext({});

export default LanguageFormContext;